var jsxRuntime = {exports: {}};

export { jsxRuntime as __module };
